export const General = Object.freeze({
    APP_IN_DEVELOPMENT_MODE: true,
    REGION: 'Atlantic/Cape_Verde',
    Locale: 'pt',
    // WEEK_DAYS_STR: ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'],
    // MONTH_DAYS_STR: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],

});

export const ErrorCode = Object.freeze({
    WRONG_CLIENT_SECRET: 1,
    INVALID_CREDENTIALS: 2,
    WRONG_PASSWORD: 3,
    NO_PERMISSION: 4,
    BRANCH_NO_ACCESS: 5,
    USER_NO_ACCESS: 6,
    EMAIL_DOES_NOT_EXIST: 7,
    VALIDATION_FAILED: 10,

    ERROR: 999,
});

export const Global = Object.freeze({
    MODAL_WIDTH: '1000px',
    ROWS_PER_PAGE: [10, 25, 50, 100],
    ARTICLE_TRANSACTION_SELL: 1,
    ARTICLE_TRANSACTION_PURCHASE: 2,
    ARTICLE_TRANSACTION_BUDGET: 3,

});

export const Tax = Object.freeze({
    TAX_REMPE: 4,
    TAX_CONTABILIDADE_ORGANIZADA: 15,
});

export const InvoiceOrigin = Object.freeze({
    SellInvoices: 1,
    PurchaseInvoices: 2,
});

export const Model = Object.freeze({
    ARTICLE: 'article',
    COMPANY: 'company',
    CLIENT: 'client',
    PROVIDER: 'provider'
});

export const Types = Object.freeze({
    article:{
        SERVICO: 1,
        PRODUTO: 2,
    },
    sell_situation: {
        ABERTO: 3,
        EM_ANDAMENTO: 4,
        CONCRETIZADO: 5,
        CANCELADO: 6,
    },
    sell_channel: {
        PRESENCIAL: 7,
        TELEFONE: 8,
        EMAIL: 9,
    },
    purchase_method: {
        CHEQUE: 10,
        DINHEIRO: 11,
        CARTAO_CREDITO: 12,
        CARTAO_DEBITO: 13,
    },
    purchase_condition: {
        PRONTO_PAGAMENTO: 14,
        PRESTACAO: 15,
        PAGAMENTO_A_PRAZO: 49,
        AVENCA: 51,
    },
    company_type: {
        REMPE: 16,
        CONTABILIDADE_ORGANIZADA: 17,
        PESSOA_SINGULAR: 18,
        OUTROS: 48,
    },
    company_category: {
        ENSINO: 19,
        SAUDE: 20,
        POLITICA: 21,
        PECUARIA: 22,
        AGRICULTURA: 23,
        TECNOLOGIA: 24,
    },
    currency: {
        ECV: 25,
        DOLLAR: 26,
        EURO: 27
    },
    document_type: {
        FACTURA: 28,
        FACTURA_RECIBO: 29,
        NOTA_DEBITO: 30,
        NOTA_CREDITO: 31,
        NOTA_DEVOLUCAO: 32,
        CERTIDAO_ESCRITURA: 33,
    },
    operation_type: {
        NORMAL: 34,
        OMISSAO: 35,
        CORRECAO_FAVOR_CONTRIBUINTE: 36,
        CORRECAO_FAVOR_ESTADO: 37,
        ANULADO: 38,
    },
    declaration_type: {
        NO_PRAZO: 39,
        FORA_DO_PRAZO: 40,
        SUBSTITUICAO: 41,
    },
    books: {
        VENDAS: 42,
        COMPRAS: 43,
    },
    typology: {
        INVESTIMENTO: 44,
        INVENTARIO: 45,
        OUTROS_BENS_SERVICOS: 46,
        SERVICOS: 47,
    }
    // 48 is taken.
});

export const Permissions = Object.freeze({
    ARTICLE_VIEW: 1,
    ARTICLE_ADD: 2,
    ARTICLE_UPDATE: 3,
    ARTICLE_DELETE: 4,

    CLIENT_VIEW: 5,
    CLIENT_ADD: 6,
    CLIENT_UPDATE: 7,
    CLIENT_DELETE: 8,

    PROVIDER_VIEW: 9,
    PROVIDER_ADD: 10,
    PROVIDER_UPDATE: 11,
    PROVIDER_DELETE: 12,

    USER_VIEW: 13,
    USER_ADD: 14,
    USER_UPDATE: 15,
    USER_DELETE: 16,
    USER_CHANGE_PASS: 17,

    SELL_VIEW: 18,
    SELL_ADD: 19,
    SELL_UPDATE: 20,
    SELL_DELETE: 21,

    PURCHASE_VIEW: 22,
    PURCHASE_ADD: 23,
    PURCHASE_UPDATE: 24,
    PURCHASE_DELETE: 25,

    INVOICE_PAYMENT: 26,
    INVOICE_RECEIPT_DELETE: 27,
    INVOICE_NOTA_DEBITO: 28,
    INVOICE_NOTA_CREDITO: 29,

    BUDGET_VIEW: 30,
    BUDGET_ADD: 31,
    BUDGET_UPDATE: 32,
    BUDGET_DELETE: 33,

    STOCK_VIEW: 34,
    STOCK_ADD: 35,
    STOCK_UPDATE: 36,
    STOCK_DELETE: 37,

    CASH_FLOW_VIEW: 38,
    CASH_FLOW_ADD: 39,
    CASH_FLOW_UPDATE: 40,
    CASH_FLOW_DELETE: 41,
});